export const services = [
  {
    id: 1,
    slug: "income-tax-gst-compliance",
    title: "Income Tax & GST Compliance",
    tagline: "Expert Income Tax and GST filing and advisory services to ensure full compliance and maximum savings for individuals and businesses across India.",
    icon: "Receipt",
    overview: "Our Income Tax and GST compliance services cover the entire spectrum of direct and indirect taxation. We handle everything from return filing and advance tax planning to GST registration, reconciliation, and audit support. Our team ensures that every filing is accurate, timely, and optimized for maximum legitimate savings. We stay ahead of regulatory changes so you don't have to worry about compliance gaps or penalties.",
    whatWeCover: [
      "Income Tax Return filing for Individuals, HUFs, Firms & Companies",
      "GST Registration, Monthly/Quarterly Return Filing (GSTR-1, GSTR-3B, GSTR-9)",
      "Advance Tax computation and payment planning",
      "Tax Deducted at Source (TDS) compliance and returns",
      "Input Tax Credit (ITC) reconciliation and optimization",
      "Tax audit under Section 44AB",
      "GST Annual Return and Reconciliation Statement",
      "Response to Income Tax and GST notices",
      "Tax planning and advisory for optimal savings",
      "E-invoicing compliance and implementation"
    ],
    keyBenefits: [
      "Zero-penalty compliance track record",
      "Maximum legitimate tax savings through strategic planning",
      "Real-time GST reconciliation preventing ITC losses",
      "Dedicated tax expert assigned to your business",
      "Proactive advisory on regulatory changes",
      "Digital-first approach with cloud-based document management"
    ],
    whoIsThisFor: [
      "Salaried professionals with multiple income sources",
      "Small and medium business owners",
      "Startups and new companies requiring GST registration",
      "E-commerce sellers needing multi-state GST compliance",
      "Companies facing tax notices or audits"
    ],
    faqs: [
      { q: "What is the deadline for filing Income Tax returns?", a: "For individuals and non-audit cases, the deadline is July 31st. For businesses requiring audit, it is October 31st. We recommend filing well before the deadline to avoid last-minute issues." },
      { q: "Do I need GST registration?", a: "GST registration is mandatory if your annual turnover exceeds Rs. 40 lakhs (Rs. 20 lakhs for services). Even below this threshold, registration may be beneficial for claiming Input Tax Credit." },
      { q: "How do you ensure accuracy in filings?", a: "We follow a multi-step verification process including data reconciliation, cross-checking with Form 26AS/AIS, and senior review before every filing submission." },
      { q: "Can you help with past unfiled returns?", a: "Yes, we help regularize past compliance gaps including filing belated returns, responding to notices, and resolving outstanding demands." },
      { q: "What are your fees for ITR filing?", a: "Our fees depend on the complexity of your income sources and business structure. Contact us for a customized quote tailored to your specific needs." }
    ]
  },
  {
    id: 2,
    slug: "roc-corporate-compliance",
    title: "ROC & Corporate Compliance",
    tagline: "Comprehensive ROC filing, corporate governance, and regulatory compliance services for private limited companies, LLPs, and other entities.",
    icon: "Building2",
    overview: "Navigating the complex requirements of the Registrar of Companies (ROC) and corporate law demands expertise and precision. Our ROC and Corporate Compliance services ensure your company stays fully compliant with the Companies Act, 2013, and all related regulations. From annual filings to board resolutions, we handle the complete corporate compliance lifecycle so you can focus on growing your business.",
    whatWeCover: [
      "Annual ROC filing (AOC-4, MGT-7/MGT-7A)",
      "Company incorporation and registration",
      "LLP registration and annual compliance",
      "Director KYC (DIR-3 KYC) and appointments",
      "Board meeting and AGM compliance",
      "Statutory register maintenance",
      "Share transfer and allotment filings",
      "Charge creation and modification",
      "Company name change and alteration of MOA/AOA",
      "Winding up and strike-off procedures"
    ],
    keyBenefits: [
      "Complete end-to-end corporate compliance management",
      "Timely filings preventing penalties and prosecution",
      "Expert handling of complex corporate transactions",
      "Digital document management and board support",
      "Regular compliance calendar and deadline tracking",
      "Experienced company secretarial support"
    ],
    whoIsThisFor: [
      "Private Limited Companies requiring annual compliance",
      "LLPs needing registration and ongoing filings",
      "Startups setting up their first company",
      "Companies undergoing structural changes",
      "Businesses needing director or shareholder changes"
    ],
    faqs: [
      { q: "What happens if ROC filings are delayed?", a: "Delayed ROC filings attract additional fees of Rs. 100 per day of delay. Prolonged non-compliance can lead to penalties on directors and even company strike-off." },
      { q: "How often do companies need to file with ROC?", a: "Companies must file annual returns (MGT-7) and financial statements (AOC-4) every year. Additionally, event-based filings are required for changes in directors, registered office, etc." },
      { q: "Can you help incorporate a new company?", a: "Yes, we handle the complete incorporation process including name approval, DSC and DIN for directors, MOA/AOA drafting, and filing with ROC." },
      { q: "What is Director KYC?", a: "Director KYC (DIR-3 KYC) is an annual compliance requirement where every director must verify their details with MCA. The deadline is September 30th each year." },
      { q: "Do you provide company secretary services?", a: "Yes, we provide comprehensive company secretarial services including board support, statutory compliance, and regulatory advisory." }
    ]
  },
  {
    id: 3,
    slug: "accounting-bookkeeping",
    title: "Accounting & Bookkeeping Systems",
    tagline: "Technology-driven accounting and bookkeeping systems that give you real-time financial visibility and control over your business operations.",
    icon: "Calculator",
    overview: "Modern businesses need more than basic bookkeeping. Our Accounting & Bookkeeping Systems service builds complete financial infrastructure for your business using cloud-based tools and automated workflows. We set up, manage, and optimize your accounting systems to ensure accurate records, timely reconciliations, and real-time financial visibility that supports better decision-making.",
    whatWeCover: [
      "Cloud accounting setup and migration (Tally, Zoho Books, QuickBooks)",
      "Day-to-day bookkeeping and transaction recording",
      "Bank reconciliation and cash flow tracking",
      "Accounts payable and receivable management",
      "Payroll processing and compliance",
      "Inventory accounting and management",
      "Multi-entity and branch accounting",
      "Chart of accounts design and optimization",
      "Automated workflow implementation",
      "Monthly closing and reconciliation processes"
    ],
    keyBenefits: [
      "Real-time financial visibility from anywhere",
      "Automated data entry reducing errors by 90%",
      "Integrated system connecting accounting with compliance",
      "Scalable systems that grow with your business",
      "Cost savings through efficient process automation",
      "Audit-ready books maintained year-round"
    ],
    whoIsThisFor: [
      "Startups needing to set up accounting from scratch",
      "Growing businesses outgrowing spreadsheet-based tracking",
      "Companies migrating to cloud-based accounting",
      "Businesses needing payroll management",
      "Multi-location businesses requiring consolidated accounting"
    ],
    faqs: [
      { q: "Which accounting software do you recommend?", a: "We recommend software based on your business size, complexity, and budget. Tally Prime is excellent for Indian compliance, while Zoho Books offers great cloud capabilities for growing businesses." },
      { q: "Can you migrate our existing data?", a: "Yes, we handle complete data migration from your existing system including historical transactions, opening balances, and master data." },
      { q: "How quickly can you set up our accounting system?", a: "A basic cloud accounting setup takes 1-2 weeks. Complex implementations with data migration and customization may take 3-4 weeks." },
      { q: "Do you handle payroll processing?", a: "Yes, we manage complete payroll processing including salary computation, PF/ESI compliance, TDS deduction, and payslip generation." },
      { q: "Will we have access to our books in real-time?", a: "Absolutely. With cloud accounting, you get 24/7 access to your financial data through web and mobile apps with role-based access controls." }
    ]
  },
  {
    id: 4,
    slug: "financial-reporting-mis",
    title: "Financial Reporting & MIS",
    tagline: "Actionable financial reports and management information systems that transform raw data into strategic business insights.",
    icon: "BarChart3",
    overview: "Data without analysis is just noise. Our Financial Reporting & MIS services transform your financial data into clear, actionable insights through customized dashboards, reports, and analysis frameworks. We design and implement Management Information Systems tailored to your business needs, enabling leadership to make informed decisions backed by accurate, timely financial intelligence.",
    whatWeCover: [
      "Monthly/Quarterly Financial Statements preparation",
      "Management Information System (MIS) design and implementation",
      "Custom dashboard creation and automation",
      "Cash flow analysis and forecasting",
      "Profitability analysis by product, segment, or location",
      "Budget vs. actual variance analysis",
      "Key Performance Indicator (KPI) tracking",
      "Board reporting packages",
      "Investor and lender reporting",
      "Financial modeling and projections"
    ],
    keyBenefits: [
      "Data-driven decision making for leadership",
      "Early warning system for financial health indicators",
      "Automated report generation saving hours of manual work",
      "Customized insights relevant to your industry",
      "Clear visibility into profitability and cash flow",
      "Investor-ready financial packages"
    ],
    whoIsThisFor: [
      "Growing businesses needing structured financial reporting",
      "Companies preparing for fundraising or loans",
      "Businesses with multiple revenue streams or locations",
      "Leadership teams seeking better financial visibility",
      "Companies undergoing rapid growth needing scalable reporting"
    ],
    faqs: [
      { q: "What kind of reports will we receive?", a: "You'll receive customized monthly reports including P&L, Balance Sheet, Cash Flow, key ratios, and business-specific KPIs. Report format is tailored to your needs." },
      { q: "Can you integrate with our existing software?", a: "Yes, we integrate with all major accounting software, ERPs, and business tools to pull data automatically for reporting." },
      { q: "How often are MIS reports generated?", a: "Standard MIS reports are generated monthly with weekly flash reports for critical metrics. We can customize the frequency based on your requirements." },
      { q: "Do you help with financial projections?", a: "Yes, we build financial models for projections, scenario analysis, and business planning to support strategic decision-making." },
      { q: "Can this help with our bank loan application?", a: "Absolutely. Well-structured financial reports and projections significantly improve your credibility with banks and investors." }
    ]
  },
  {
    id: 5,
    slug: "business-consulting-strategy",
    title: "Business Consulting & Strategy",
    tagline: "Strategic advisory that bridges the gap between where your business is today and where you want it to be tomorrow.",
    icon: "Briefcase",
    overview: "Our Business Consulting & Strategy service goes beyond traditional advisory. We work as an extension of your leadership team, bringing deep industry knowledge and practical execution experience to solve real business challenges. Whether you're starting up, scaling, or restructuring, our consultants develop and implement strategies that drive measurable growth and operational excellence.",
    whatWeCover: [
      "Business plan development and validation",
      "Market entry and expansion strategy",
      "Operational efficiency and process improvement",
      "Organizational structure and HR advisory",
      "MSME registration and government scheme advisory",
      "Business valuation and due diligence",
      "Mergers, acquisitions, and restructuring advisory",
      "Digital transformation roadmap",
      "Pricing strategy and revenue optimization",
      "Risk assessment and mitigation planning"
    ],
    keyBenefits: [
      "Practical strategies backed by real execution experience",
      "Access to cross-industry insights and best practices",
      "Structured approach to complex business challenges",
      "Support in accessing government schemes and incentives",
      "Measurable ROI on consulting engagements",
      "Long-term strategic partnership beyond one-time advisory"
    ],
    whoIsThisFor: [
      "Entrepreneurs launching new ventures",
      "SMEs looking to scale operations",
      "Businesses facing operational challenges",
      "Companies exploring new markets or products",
      "Organizations undergoing digital transformation"
    ],
    faqs: [
      { q: "How is your consulting different from others?", a: "We combine strategic thinking with hands-on execution. Our consultants have real business experience, not just theoretical frameworks. We stay involved through implementation." },
      { q: "Can you help with MSME registration?", a: "Yes, we handle complete MSME/Udyam registration and guide you on leveraging government schemes, subsidies, and priority sector lending benefits." },
      { q: "What industries do you serve?", a: "We serve across industries including manufacturing, services, technology, retail, healthcare, and education. Our frameworks adapt to any industry context." },
      { q: "How long does a consulting engagement last?", a: "Engagements range from one-time assessments (2-4 weeks) to ongoing advisory retainers. Duration depends on scope and complexity of the challenge." },
      { q: "Do you help with business loans and funding?", a: "Yes, we assist with business plan preparation, financial projections, and documentation required for bank loans, MSME schemes, and investor pitches." }
    ]
  },
  {
    id: 6,
    slug: "end-to-end-compliance",
    title: "End-to-End Business Compliance Solutions",
    tagline: "One partner for all your compliance needs. From company formation to ongoing regulatory management, we handle everything.",
    icon: "Layers",
    overview: "Running a compliant business in India requires managing multiple registrations, filings, and deadlines across various authorities. Our End-to-End Business Compliance Solutions bring everything under one roof. We become your single point of contact for all compliance requirements, managing the complete lifecycle from entity formation through ongoing annual filings and regulatory changes.",
    whatWeCover: [
      "Company/LLP/Partnership formation and registration",
      "PAN, TAN, GST, MSME, and all statutory registrations",
      "Income Tax compliance and annual filing",
      "GST compliance and monthly/quarterly returns",
      "ROC annual filings and corporate compliance",
      "TDS/TCS compliance and quarterly returns",
      "PF, ESI, and labor law compliance",
      "Professional Tax registration and compliance",
      "FSSAI, Trade License, and industry-specific licenses",
      "Compliance calendar management and deadline tracking"
    ],
    keyBenefits: [
      "Single point of contact for all compliance needs",
      "Zero missed deadlines with proactive tracking",
      "Significant cost savings vs. managing multiple vendors",
      "Comprehensive compliance health dashboard",
      "Scalable service that grows with your business",
      "Peace of mind knowing every requirement is covered"
    ],
    whoIsThisFor: [
      "New businesses needing complete setup from day one",
      "Existing businesses with fragmented compliance management",
      "Companies tired of managing multiple service providers",
      "Fast-growing businesses needing scalable compliance",
      "Business owners who want to focus on growth, not paperwork"
    ],
    faqs: [
      { q: "What all registrations does a new business need?", a: "A typical new business needs PAN, TAN, GST, MSME registration, Professional Tax, and potentially PF/ESI registration depending on employee count. We guide you through the entire process." },
      { q: "How do you track all compliance deadlines?", a: "We maintain a comprehensive compliance calendar for each client with automated reminders, regular reviews, and a dedicated compliance manager ensuring nothing is missed." },
      { q: "Can you take over from our current CA/provider?", a: "Absolutely. We handle smooth transitions including document collection, data migration, and catching up on any pending filings." },
      { q: "Is this suitable for a one-person company?", a: "Yes, our services scale from sole proprietorships to large companies. We customize the scope and pricing based on your actual compliance requirements." },
      { q: "What makes end-to-end better than hiring separate providers?", a: "With one provider, you get coordinated compliance, no communication gaps, consistent quality, and significant cost savings. All your compliance data is in one place." }
    ]
  }
];
